import { useEffect, useState } from 'react'

import { getSession, getStorage, setSession, setStorage } from '@/lib/utils'
import { Feature as FeatureType } from '@/types'

const getStorageKey = (uid: string) => `feature.display-${uid}`

const shouldAutoOpen = (feature: FeatureType) => {
  const { display = 'always' } = feature.config || {}
  const storageKey = getStorageKey(feature.uid)

  if (display === 'always') return true
  if (display === 'once') return !getStorage(storageKey)
  if (display === 'session') return !getSession(storageKey)
  return false
}

export default function usePopupQueue(popups: FeatureType[]) {
  const [isMounted, setIsMounted] = useState(false)
  const [closedUids, setClosedUids] = useState<string[]>([])

  useEffect(() => setIsMounted(true), [])

  const pendingPopups = popups.filter(
    popup => !closedUids.includes(popup.uid) && (!isMounted || shouldAutoOpen(popup))
  )

  const close = (feature: FeatureType) => {
    const { display } = feature.config || {}
    const storageKey = getStorageKey(feature.uid)

    if (display === 'once') setStorage(storageKey, true)
    else if (display === 'session') setSession(storageKey, true)
    setClosedUids(prev => [...prev, feature.uid])
  }

  return {
    activeUid: isMounted ? pendingPopups[0]?.uid : undefined,
    hasPending: pendingPopups.length > 0,
    close
  }
}
